export const MIN_PORTRAIT = Object.freeze({ width: 600, height: 800 });

export const isLowResolution = ({ width, height }) =>
  width < MIN_PORTRAIT.width || height < MIN_PORTRAIT.height;
